/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { Dropdown as BasicDropdown } from 'ember-basic-dropdown/components/basic-dropdown';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { or } from '@ember/object/computed';
import Component from '@glimmer/component';
import AccountModel from 'cio/models/account';
import MasqService from 'cio/services/masq';
import AuthService from 'cio/services/auth';
import RouterService from '@ember/routing/router-service';
import {
  USER_ROLE_ADMIN,
  USER_ROLE_MANAGER,
  USER_ROLE_AUTHOR,
  USER_ROLE_VIEWER,
  USER_ROLE_AUTHOR_REDACT,
  USER_ROLE_VIEWER_REDACT,
} from 'cio/utils/user-roles';
import MomentService from 'cio/services/moment';
import { next } from '@ember/runloop';
import FeaturesService from 'ember-feature-flags/services/features';
import DS from 'ember-data';
import { task } from 'ember-concurrency';

interface AccountDropdownArgs {
  account: AccountModel;
  onLogOut: () => unknown;
}

export default class AccountDropdown extends Component<AccountDropdownArgs> {
  @service masq!: MasqService;
  @service auth!: AuthService;
  @service router!: RouterService;
  @service moment!: MomentService;
  @service features!: FeaturesService;
  @service store!: DS.Store;

  constructor(owner: unknown, args: AccountDropdownArgs) {
    super(owner, args);
    this.maybeLoadAccountUsageTask.perform();
  }

  maybeLoadAccountUsageTask = task(async () => {
    if (this.auth.hasPermission('account/view')) {
      try {
        await this.store.queryRecord('account-usage', {});
      } catch {
        // We didn't manage to load account usage. That's okay—the UI will have
        // indicators to tell users that their usage data may be incorrect. We
        // should still render the rest of the app.
      }
    }
  });

  @or('args.account.name', 'args.account.email') name!: string;

  get _currentUserRoleString() {
    let user = this.args.account.currentUser;

    return {
      [USER_ROLE_ADMIN]: 'an Admin',
      [USER_ROLE_MANAGER]: 'a Manager',
      [USER_ROLE_AUTHOR]: 'an Author',
      [USER_ROLE_VIEWER]: 'a Viewer',
      [USER_ROLE_AUTHOR_REDACT]: 'an Author',
      [USER_ROLE_VIEWER_REDACT]: 'a Viewer',
    }[user.role];
  }

  @action
  disableAdmin(dropdown: BasicDropdown) {
    dropdown.actions.close();
    this.masq.toggleAdmin();
  }

  @action
  closeDropdown(dd: BasicDropdown) {
    next(dd, dd.actions.close);
  }
}
